import api from './api';

export const progressService = {
  getDashboardStats: async () => {
    const response = await api.get('/progress/dashboard');
    return response.data;
  },

  getCourseProgress: async (courseId) => {
    const response = await api.get(`/progress/course/${courseId}`);
    return response.data;
  },

  getModuleProgress: async (moduleId) => {
    const response = await api.get(`/progress/module/${moduleId}`);
    return response.data;
  },

  getLessonProgress: async (lessonId) => {
    const response = await api.get(`/progress/lesson/${lessonId}`);
    return response.data;
  },

  updateLessonProgress: async (lessonId, progressData) => {
    const response = await api.post(`/progress/lesson/${lessonId}`, progressData);
    return response.data;
  },
};

